import script from "./ProjectReportingInvoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectReportingInvoices.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectReportingInvoices.vue?vue&type=style&index=0&id=62bf8bda&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62bf8bda"]])

export default __exports__